import React from "react";
import { Tag } from "@blueprintjs/core";
import { CSSProperties } from "react";
import { format_status_nivy } from "../../utils";
import moment from "moment";

const tagStyle: CSSProperties = {
  width: "70%",
  textAlign: "center"
};

/**
 * Função responsável por retornar uma tag com texto e estilo baseados no status e tipo fornecidos.
 * Ela formata o texto e as classes CSS para refletir o estado de um processo com base no status do DAE.
 * 
 * @param {string | number} status - O status que define o tipo de tag a ser exibida.
 * @param {string} [tipo] - O tipo de operação que pode influenciar o texto e as classes da tag.
 * @param {CSSProperties} [customStyles] - Estilos CSS personalizados a serem aplicados à tag.
 * @returns {JSX.Element} A tag formatada com o texto e as classes CSS adequadas ao status e tipo.
 */
export function getTag(status: string | number, tipo?: string, row?: any, customStyles?: CSSProperties) {
  let tagText = "";
  let className = "tagConfirmacao tagDownload";

  const status_ = format_status_nivy(status);

  switch (status_) {
    case 0:
      tagText = 
        ["solicitacao_sefa", "download_sefa"].includes(tipo) ? "NOVA SOLICITAÇÃO" :
        "NOVO";
      className += " tagNovo";
      break;

    case 1:
      tagText = 
        ["solicitacao_sefa", "download_sefa"].includes(tipo) ? "PROCESSANDO SOLICITAÇÃO" :
        "PROCESSANDO";
      className += " tagProcessando";
      break;

    case 2:
      tagText = 
        tipo === "dec_sefa_ler" ? "CONCLUÍDO SEM MENSAGEM" :
        "CONCLUÍDO";

      className += 
        tipo === "dec_sefa_ler" ? " tagSemArquivos" :
        " ";
      break;

    case 3:
      tagText = 
        ["xml_integration", "calculo"].includes(tipo) ? "CONCLUÍDO COM ERROS" : 
        tipo === "dec_sefa_ler" ? "ERRO LEITURA" :
        "ERRO SOLICITAÇÃO";
      className += " tagNao";
      break;

    case 4:
      tagText = 
        tipo === "xml_integration" ? "AGUARDANDO VALIDAÇÃO TOKEN" :
        tipo === "sitfis" ? "AGUARDANDO SERPRO" :
        tipo === "download_sefa" ? "NOVO DOWNLOAD" :
        tipo === "solicitacao_sefa" ? "CONCLUÍDA SOLICITAÇÃO" :
        tipo === "dec_sefa_ler" ? "MENSAGEM PENDENTE" :
        tipo === "manifestacao_chaves" ? "CONSUMO INDEVIDO" :
        "CONCLUÍDO COM ERROS";

      className += 
        tipo === "xml_integration" ? " tagProcessando" :
        tipo === "sitfis" ? " tagAguardandoDownload" :
        tipo === "download_sefa" ? " tagNovo" :
        tipo === "solicitacao_sefa" ? "" :
        tipo === "dec_sefa_ler" ? " tagProcessando" :
        tipo === "manifestacao_chaves" ? " tagAguardandoDownload" :
        " tagNao";
        
      break;

    case 5:
      tagText = 
        tipo === "xml_integration" ? "ERRO" :
        tipo === "sitfis" ? "NOVA TENTATIVA" :
        tipo === "download_sefa" ? "ERRO DOWNLOAD" :
        tipo === "solicitacao_sefa" ? "CONCLUÍDA SOLICITAÇÃO" :
        tipo === "dec_sefa_download" ? "ERRO DOWNLOAD" :
        tipo === "nfe_fazenda" ? "CONCLUÍDO SEM CHAVES" :
        "CONCLUÍDO SEM ARQUIVOS";

      className += 
        tipo === "xml_integration" ? " tagNao" :
        tipo === "sitfis" ? " tagProcessando" :
        tipo === "download_sefa" ? " tagNao" :
        tipo === "solicitacao_sefa" ? " " :
        tipo == "dec_sefa_download" ? " tagNao" :
        " tagSemArquivos";
      break;

    case 6:
      tagText = "AGUARDANDO ARQUIVOS PENDENTES";
      className += " tagAguardandoDownload";
      break;

    case 7:
      tagText = "ENVIADO À FILA";
      className += " tagProcessando";
      break;

    case 8:
      tagText = "CANCELADO";
      className += " tagCancelado";
      break;

    case 9:
      tagText = "ERRO FATAL";
      className += " tagNao";
      break;

    case 10:
      tagText = "CONCLUÍDO SEM ARQUIVOS";
      className += " tagSemArquivos";
      break;

    case 11:
      tagText =
        ["solicitacao_sefa", "download_sefa"].includes(tipo) && (moment((row.data_agendamento)).add(3, "hours").unix() < moment().unix()) ? "ERRO AGENDAMENTO" :
        ["solicitacao_sefa", "download_sefa"].includes(tipo) ? `AGENDAMENTO - ${moment(row.data_agendamento).add(3, "hours").format("DD/MM/YYYY")}` :
        "NÃO DISPONÍVEL"

      className +=
        ["solicitacao_sefa", "download_sefa"].includes(tipo) && (moment((row.data_agendamento)).add(3, "hours").unix() < moment().unix()) ? " tagNao" :
        " tagNovo"
      break;

    case 12:
      tagText = "CONCLUÍDO COM ERRO";
      className += " tagNao";
      break;

    case 13:
      tagText = "AGUARDANDO HORÁRIO";
      className += " tagNovo";
      break;

    case 14:
      tagText = "CONCLUÍDO COM PENDÊNCIAS";
      className += " tagSemArquivos";
      break;

    case 15:
      tagText = "ERRO SOLICITAÇÃO";
      className += " tagNao";
      break;

    case 16:
      tagText = "AGUARDANDO DIA UTIL";
      className += " tagNovo";
      break;

    default:
      tagText = "NÃO DISPONÍVEL"
      className += " tagNovo"
      break;

    }

  return (<Tag className={className} style={{ ...tagStyle, ...customStyles }}>{tagText}</Tag>);
};

/**
 * Função responsável por gerar um array de opções com base no tipo de operação.
 * As opções retornadas dependem do tipo fornecido, refletindo diferentes estados de um processo.
 * 
 * @param {string} tipo - O tipo de operação que determina as opções a serem geradas.
 * @returns {Array} Um array de objetos contendo `value` e `label`, representando as opções filtradas e ordenadas.
 */
export function getOptions(tipo: string) {
  let tagText: any = {};

  const options = [
    { value: "", label: "TODOS" },
    { value: "6", label: "AGUARDANDO ARQUIVOS PENDENTES" },
    { value: "7", label: "ENVIADO À FILA" },
    { value: "8", label: "CANCELADO" },
    { value: "9", label: "ERRO FATAL" },
    { value: "10", label: "CONCLUÍDO SEM ARQUIVOS" },
    { value: "11", label: "ERRO AGENDAMENTO" },
    { value: "12", label: "CONCLUÍDO COM ERRO" },
    { value: "13", label: "AGUARDANDO HORÁRIO" },
    { value: "14", label: "CONCLUÍDO COM PENDÊNCIAS" },
    { value: "15", label: "ERRO SOLICITAÇÃO" },
    { value: "16", label: "AGUARDANDO DIA ÚTIL" },
  ];

  tagText = 
    tipo === "download_sefa" ? { value: "0", label: "NOVA SOLICITAÇÃO" } :
    tipo === "solicitacao_sefa" ? { value: "0", label: "NOVA SOLICITAÇÃO" } :
    { value: "0", label: "NOVO" };

  options.push(tagText)

  tagText = 
    tipo === "download_sefa" ? { value: "1", label: "PROCESSANDO SOLICITAÇÃO" } :
    tipo === "solicitacao_sefa" ? { value: "1", label: "PROCESSANDO SOLICITAÇÃO" } :
    { value: "1", label: "PROCESSANDO" };

  options.push(tagText)

  tagText = 
    tipo === "dec_sefa_ler" ? { value: "2", label: "CONCLUÍDO S/MENSAGEM" } :
    { value: "2", label: "CONCLUÍDO" };

  options.push(tagText)

  tagText = 
    tipo === "dec_sefa_ler" ? { value: "3", label: "ERRO LEITURA" } :
    { value: "3", label: "ERRO SOLICITAÇÃO" };

  options.push(tagText)

  tagText = 
    tipo === "xml_integration" ? { value: "4", label: "AGUARDANDO VALIDAÇÃO TOKEN" } :
    tipo === "sitfis" ? { value: "4", label: "AGUARDANDO SERPRO" } :
    tipo === "download_sefa" ? { value: "4", label: "NOVO DOWNLOAD" } :
    tipo === "solicitacao_sefa" ? { value: "4", label: "CONCLUÍDA SOLICITAÇÃO" } :
    tipo === "dec_sefa_ler" ? { value: "4", label: "MENSAGEM PENDENTE" } :
    tipo === "manifestacao_chaves" ? { value: "4", label: "CONSUMO INDEVIDO" } :
    { value: "4", label: "CONCLUÍDO COM ERROS" };

  options.push(tagText);

  tagText = 
    tipo === "xml_integration" ? { value: "5", label: "ERRO" } :
    tipo === "sitfis" ? { value: "5", label: "NOVA TENTATIVA" } :
    tipo === "download_sefa" ? { value: "5", label: "ERRO DOWNLOAD" } :
    tipo === "solicitacao_sefa" ? { value: "5", label: "CONCLUÍDA SOLICITAÇÃO" } :
    tipo === "dec_sefa_download" ? { value: "5", label: "ERRO DOWNLOAD" } :
    tipo === "nfe_fazenda" ? { value: "5", label: "CONCLUÍDO SEM CHAVES" } :
    { value: "5", label: "CONCLUÍDO SEM ARQUIVOS" };

  options.push(tagText);

  return options.sort((a, b) => Number(a.value) - Number(b.value));

};

export const options = [
  {cod: "caixapostal", descricao: "CAIXA POSTAL"},
  {cod: "calculo", descricao: "CÁLCULO"},
  {cod: "caixa", descricao: "CNDS - FGTS"},
  {cod: "tst", descricao: "CNDS - TRABALHISTA"},
  {cod: "receita", descricao: "CNDS - FEDERAL"},
  {cod: "sefa", descricao: "CNDS - SEFA"},
  {cod: "contestacao", descricao: "CONTESTAÇÃO"},
  {cod: "fgts_digital", descricao: "FGTS DIGITAL"},
  {cod: "manifestacao", descricao: "CÁLCULO MANIFESTAÇÃO"},
  {cod: "manifestacoes_download", descricao: "DOWNLOAD MANIFESTAÇÃO"},
  {cod: "parauapebas", descricao: "NFS-E PREFEITURA"},
  {cod: "pgdas", descricao: "PGDAS"},
  {cod: "gera_das", descricao: "DAS"},
  {cod: "relatorio", descricao: "RELATÓRIO"},
  {cod: "solicitacao_sefa", descricao: "SOLICITAÇÕES SEFA"},
  {cod: "download_sefa", descricao: "DOWNLOADS SEFA"},
  {cod: "sitfis", descricao: "SITFIS"},
  {cod: "sped", descricao: "SPED"},
  {cod: "xml_integration", descricao: "XML INTEGRAÇÃO"},
  {cod: "dae_avulso", descricao: "DAE AVULSO"},
  {cod: "dei", descricao: "DEI"},
  {cod: "dec_sefa_ler", descricao: "DEC SEFA LEITURA"},
  {cod: "dec_sefa_download", descricao: "DEC SEFA DOWNLOAD"},
  {cod: "nfe_fazenda", descricao: "PORTAL NF-E"},
  {cod: "manifestacao_chaves", descricao: "MANIFESTAÇÃO CHAVES"},
  {cod: "tarefas_danfe", descricao: "TAREFAS NFS-ES"},
  {cod: "parcelamentos", descricao: "PARCELAMENTOS"},
  {cod: "email", descricao: "NOTIFICAÇÃO - EMAIL"},
  {cod: "telegram", descricao: "NOTIFICAÇÃO - TELEGRAM"},
  {cod: "whatsapp", descricao: "NOTIFICAÇÃO - WHATSAPP"},
  {cod: "det", descricao: "DET"}
]